import { getApiGalaxyServer } from 'services';
import * as constants from '@constants';
import { AxiosResponse } from 'axios';
import ApiClientManager from 'core/apiClient';

export interface CheckIsBakIntegrationPayload {
  serviceName: constants.IntegrationAgentNames;
  targetServiceId: number;
  /** Optional tenant for header override */
  tenant?: string;
  /** Optional realmId for header override */
  realmId?: string;
}

export type CheckIsBakIntegrationSuccessResponse = AxiosResponse<{
  isBakIntegration: boolean;
}>;

export type CheckIsBakIntegrationErrorResponse = AxiosResponse<{ error: string }>;

export const checkIsBakIntegrationApi = ({
  params: { serviceName, targetServiceId, tenant, realmId },
  token,
  config,
}: BaseApiParams<CheckIsBakIntegrationPayload>) => {
  // Build custom headers if tenant/realmId are provided to override global cache
  const customHeaders =
    tenant && realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: tenant, realmId })
      : undefined;

  return getApiGalaxyServer(
    `/integrations_api/forward/${serviceName}/provision/isBakIntegration/${targetServiceId}`,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
